export const dataSelector = (state) => state.data;
